import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Nav from "./Components/Nav";
import Home from "./pages/Home";
import SignIn from "./pages/SignIn";
import HashLoader from "react-spinners";

function App() {
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/signin" component={SignIn} exact />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
